import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { routeTree } from './routeTree.gen';
import './assets/styles/index.css';

/**
 * QueryClient の設定
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 5分間は fresh と見なす
      staleTime: 5 * 60 * 1000,
      // エラー時のリトライは 1 回まで
      retry: 1,
    },
  },
});

/**
 * Router の設定
 * context に queryClient を渡す
 */
const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  // ホバー時にプリフェッチ
  defaultPreload: 'intent',
});

// TanStack Router の型定義
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * App Root
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>,
);
